import { render, staticRenderFns } from "./WorkTemp.vue?vue&type=template&id=23ce33ea&scoped=true&"
import script from "./WorkTemp.vue?vue&type=script&lang=js&"
export * from "./WorkTemp.vue?vue&type=script&lang=js&"
import style0 from "./WorkTemp.vue?vue&type=style&index=0&id=23ce33ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ce33ea",
  null
  
)

export default component.exports